import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GATEWAY_ROUTER_STRIPE_CREATE_CHARGE_CONFIG = defineFcm('gateway_router_stripe_create_charge_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
				supported_currencies: { type: 'array', shape: { type: 'string' } },
				supported_payment_method_brands: { type: 'array', shape: { type: 'string' } },
				supported_payment_method_countries: { type: 'array', shape: { type: 'string' } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
